import { render, staticRenderFns } from "./dashboardQuote.vue?vue&type=template&id=85058514&scoped=true&"
import script from "./dashboardQuote.vue?vue&type=script&lang=js&"
export * from "./dashboardQuote.vue?vue&type=script&lang=js&"
import style0 from "./dashboardQuote.vue?vue&type=style&index=0&id=85058514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85058514",
  null
  
)

export default component.exports